<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Move Asset</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <div class="input-container">
            <span class="label">Job Site</span>
            <span class="label">{{jobsiteName}}</span>
        </div>
        <div class="input-container">
            <span class="label">Date</span>
            <span class="input-icon input-icon--mat cursor-pointer get-date-icon" (click)="picker.open()" matTooltip="{{ttDate}}">
                <i class="material-icons">date_range</i>
            </span>
            <input type="text" [matDatepicker]="picker" class="get-Input-date"
                   [min]="minDate" [max]="maxDate" placeholder="Choose a date"
                   [(ngModel)]="eventDate" (ngModelChange)="dateChanged()"
                   readonly="readonly" style="color: black">
            <mat-datepicker #picker></mat-datepicker>
        </div>
        <div class="input-container">
            <span class="label">Equipment SMU</span>
            <input type="number" class="get-Input" value="0" min="0" [(ngModel)]="smu" (ngModelChange)="smuChanged()" />
            <span class="input-icon get-icon">Hrs</span>
        </div>
        <!-- <div class="input-container">
            <span class="label">Cost</span>
            <span class="input-icon get-icon">$</span>
            <input type="number"   class="get-Input-cost" value="0.00" min="0" [(ngModel)]="cost" (ngModelChange)="costChanged()" step="any" />
        </div> -->
        
        <div class="input-container">
            <span class="label">Implement Status</span>
            <select (change)="statusSelected($event.target.value)" class="get-Input">
                <option value="" disabled selected>Select Status</option>
                <option *ngFor="let status of statusList" [value]="status.Id">{{status.Name}}</option>
            </select>
        </div>
        <!--TT-5935-->
        <!-- <div class="input-container" *ngIf="showRepairerAndWorkshop">
            <span class="label">Repairer</span>
            <div>
                <select class="margin-right-8 get-Input" [(ngModel)]="selectedRepairerId" (change)="repairerSelected($event.target.value)">
                    <option value="" disabled selected>Select Repairer</option>
                    <option *ngFor="let repairer of repairerList" [value]="repairer.Id">{{repairer.Name}}</option>
                </select>
                <button mat-icon-button (click)="addRepairer()">
                    <mat-icon>add</mat-icon>
                </button>
               
            </div>
        </div>
        <div class="input-container" *ngIf="showRepairerAndWorkshop">
            <span class="label">Location</span>
            <div>
                <select class="margin-right-8 get-Input"  [(ngModel)]="selectedWorkshopId" (change)="workshopSelected($event.target.value)">
                    <option value="" disabled selected>Select Location</option>
                  
                    <option *ngFor="let workshop of workshopList" [value]="workshop.Id">{{workshop.Name}}</option>
                </select>
                <button mat-icon-button (click)="addWorkshop()"  *ngIf="showAddWorkshop">
                    <mat-icon>add</mat-icon>
                </button>
               
            </div>
        </div> -->
        <div class="margin-bottom-16">Comment</div>
        <textarea rows="4" maxlength="256" [(ngModel)]="comment" (ngModelChange)="commentChanged()"  class="textAreaComment"
                  placeholder="Enter a comment about why the implement status was changed. "
                  matTooltip="{{ttComment}}"></textarea>
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></a>
    </div>
</div>